export default __webpack_public_path__ + "static/media/gameplay-icon-4.0186bf2d.gif";